<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text1 fl" style="margin-right: 20px;">
					<p>患者注册总人数</p>
					<p>{{hzzczs}}</p>
				</div>
				<div class="text2">
					<p>昨日新增</p>
					<p>{{hzzczs_jt}}</p>
				</div>
				<div class="text1 fl"  style="margin-right: 20px;">
					<p>医生录入</p>
					<p>{{pdmlr}}</p>
				</div>
				<div class="text2">
					<p>七日新增</p>
					<p>{{hzzczs_7t}}</p>
				</div>
				<div class="text1">
					<p>医患通授权</p>
					<p>{{yhtsq}}</p>
					<!--<p>{{hzzczs-pdmlr}}</p>-->
				</div>
					
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value1"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="dateFn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btnStr==7?'active':''" @click="dayFn(7)">近7日</div>
						<div :class="btnStr==30?'active':''" @click="dayFn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options1" :dates="value1"  :datazs="zczs" :datazc="zcxz" :datafb="zcxz1"></charts>
					</div>
					<div>
						<charts :type="2" :options="options1" :dates="value1"  :datazs="zczs" :datazc="zcxz" :datafb="zcxz1"></charts>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="numDoctor">
				<div class="text1">
					<p>激活患者总人数</p>
					<!--<p>{{jhhzzrs}}</p>-->
					<p>{{0}}</p>
				</div>
				<div class="text2">
					<p>昨日新增</p>
					<!--<p>{{jhhzzrs_jt}}</p>-->
					<p>0</p>
				</div>
				<div class="text2">
					<p>七日新增</p>
					<!--<p>{{jhhzzrs_7t}}</p>-->
					<p>0</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value2"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date1Fn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btn1Str==7?'active':''" @click="day1Fn(7)">近7日</div>
						<div :class="btn1Str==30?'active':''" @click="day1Fn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options2" :dates="value2" :datazs="jhzs"></charts>
					</div>
					<div>
						<!--<charts :type="1" :options="options3"></charts>-->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {hztj_count,hz_zczrs,pdm_lrzrs,hxsqrs,jhhzzrs} from '../components/http/api.js'
	import charts from '../component/charts.vue'
	export default{
		components:{
			charts
		},
		data(){
			return{
				value1:[],
				value2:[],
				btnStr:7,
				btn1Str:7,
				options1:[{
					id:1,
					name:'患者注册总人数',
				},{
					id:2,
					name:'PDM录入人数',
				},{
					id:3,
					name:'微信授权人数',
				}],
				options2:[{
					id:1,
					name:'激活患者总人数',
				}],
				options3:[{
					id:1,
					name:'激活患者新增',
				}],
				hzNum:'',
				zczs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
		        jhzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
		        zcxz:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		         zcxz1:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        hzzczs:0,
		        pdmlr:0,
		        hzzczs_jt:0,
		        hzzczs_7t:0,
		        yhtsq:0,
		        jhhzzrs:0,
		        jhhzzrs_jt:0,
		        jhhzzrs_7t:0
			}
		},
		beforeMount() {
			this.hztj_countFn();
			this.value1=[this.getDay(-7),this.getDay(-1)];
			this.value2=[this.getDay(-7),this.getDay(-1)];
			this.hz_zczrsFn();
			this.pdm_lrzrsFn();
			this.hxsqrsFn();
			this.jhhzzrsFn();
		},
		methods:{
			dateFn(){
				this.hz_zczrsFn();
				this.pdm_lrzrsFn();
				this.hxsqrsFn()
			},
			date1Fn(){
				this.jhhzzrsFn();
			},
			hztj_countFn(){
				hztj_count().then(res=>{
					this.hzzczs=res.hzzczs
					this.pdmlr=res.pdmlr
					this.hzzczs_jt=res.hzzczs_jt
					this.hzzczs_7t=res.hzzczs_7t
					this.yhtsq=res.yhtsq
					this.jhhzzrs=res.jhhzzrs
					this.jhhzzrs_jt=res.jhhzzrs_jt
					this.jhhzzrs_7t=res.jhhzzrs_7t
				})
			},
			dayFn(i){
				this.btnStr=i;
				this.value1=[this.getDay(-i),this.getDay(-1)];
				this.hz_zczrsFn();
				this.pdm_lrzrsFn();
				this.hxsqrsFn();
			},
			day1Fn(i){
				this.btn1Str=i;
				this.value2=[this.getDay(-i),this.getDay(-1)];
				this.jhhzzrsFn();
				
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			hz_zczrsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				hz_zczrs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
//					var arr2s=[2793,2806,2820,2836,2855,2863,2884];
					this.zczs.xAxis.data=arr1;
					this.zczs.series[0].data=arr2;
				})
			},
			pdm_lrzrsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				pdm_lrzrs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
					this.zcxz.xAxis.data=arr1;
					this.zcxz.series[0].data=arr2;
				})
			},
			hxsqrsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				hxsqrs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
					this.zcxz1.xAxis.data=arr1;
					this.zcxz1.series[0].data=arr2;
				})
			},
			jhhzzrsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				jhhzzrs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
					var arr2s=[0,0,0,0,0,0,0];
					this.jhzs.xAxis.data=arr1;
					this.jhzs.series[0].data=arr2s;
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1{
		width: 60%;
		
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/hzEcharts.vue